<template>
  <div class="pay_result_box">
	<div class="pay_top_box">
		<img src="../../../assets/images/pay/success.png">
		<p>支付成功</p>
	</div>	
	<div class="pay_btom_box">
		<div class="pay_info_top">
			<p class="txt">舆情秘书</p>
			<p class="money">¥ {{sellingPrice}}</p>
		</div>	
		<div class="product_info">
			<div class="product_list flex_verticle">
				<span class="light">商品</span>
				<span class="dark flex_1 ellipsis">{{productName}}</span>
			</div>
			<div class="product_list flex_verticle">
				<span class="light">交易单号</span>
				<span class="dark flex_1 ellipsis">{{orderId}}</span>
			</div>
			<div class="product_list flex_verticle">
				<span class="light">交易时间</span>
				<span class="dark flex_1 ellipsis">{{time}}</span>
			</div>
			<div class="product_list flex_verticle">
				<span class="light">当前状态</span>
				<span class="dark flex_1 ellipsis">支付成功</span>
			</div>
			<div class="product_list flex_verticle">
				<span class="light">支付方式</span>
				<span class="dark flex_1 ellipsis">微信支付</span>
			</div>
		</div>
		<div class="pay_img">
			<img src="../../../assets/images/pay/wxpay.png">
		</div>
	</div>
	<div class="btn_box">
		<span @click="queryFileUrl">查看报告</span>
	</div>
  </div>
</template>
<script>
import moment from 'moment'
// import store from '@/store'
// import { getFileUrl } from '@/api/wechat'
export default {
  name: 'paySuccess',
  data() {
    return {
    	url: this.$route.query.url,
    	id: this.$route.query.id,
    	orderId: this.$route.query.orderId,
    	sellingPrice: this.$route.query.sellingPrice,
    	productName: this.$route.query.productName,
    	time: moment().format('YYYY-MM-DD HH:mm:ss')
    }
  },
  mounted(){
  },
  methods: {
  	moment,
    // 查询支付成功后的fileUrl
    queryFileUrl(){
    	this.$router.push({path: 'epidemicReportDetail', query: {url : this.url, id: this.id,title: this.productName,status: 2,openid:this.$store.state.userInfo.openid}});
        // let params = {
        //   openid: store.state.userInfo.openid,
        //   reportId: this.reportId,
        //   orderId: this.orderId 
        // }
        // this.data = params;
        // getFileUrl(params).then(res => {
        //   if(res.data.status == '0'){
        //     let result = res.data.result.data;
        //     let fileUrl = result.allFileUrl;
        //     let fileId = result.id;
        //     this.$router.push({path: 'epidemicReportDetail', query: {url : fileUrl, id: fileId,title: this.productName,status: 2}});
        //   }
        // }).catch(err => {
        //   console.log(err);
        // });
    }
  }
}
</script>
<style scoped>
 @import url("./success.css");
</style>